/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateLocationCommand } from '../../models/create-location-command';
import { CreateLocationCommandResult } from '../../models/create-location-command-result';

export interface ApiLocationCreateLocationPost$Params {
      body?: CreateLocationCommand
}

export function apiLocationCreateLocationPost(http: HttpClient, rootUrl: string, params?: ApiLocationCreateLocationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateLocationCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiLocationCreateLocationPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateLocationCommandResult>;
    })
  );
}

apiLocationCreateLocationPost.PATH = '/api/Location/CreateLocation';
